module.exports = __webpack_public_path__ + "img/EYE.60fbbbb8.svg";